import styled from "@emotion/styled";
import { Box, Stack } from "@mui/material";

export const StyledMyProfileNavigationStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(5),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),

  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(3),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}));
export const StyledMyProfileBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  width: "100%",
}));

export const StyledMyProfileDetailsBox = styled(Box)(() => ({
  maxWidth: "504px",
}));

export const StyledPersonalDetailsStack = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(7),
}));
